export default __webpack_public_path__ + "static/media/clock.e84db23a.svg";